enum KioskPaymentTerminalState {
  STOPPED = 0,
  INITIALIZING = 1,
  TERMINAL_SELECTION = 2,
  WAITING_FOR_TERMINAL = 3,
  CONNECTING = 4,
  UPDATING = 5,
  READY = 6,
  TRANSACTION = 7,
}

export { KioskPaymentTerminalState };
